import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, Card, Alert } from 'react-bootstrap';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaFacebook, FaTwitter, FaInstagram, FaYoutube } from 'react-icons/fa';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import './Contact.css';

const Contact: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  
  const [validated, setValidated] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  
  useEffect(() => {
    // تمرير إلى أعلى الصفحة عند التحميل
    window.scrollTo(0, 0);
  }, []);
  
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    
    // Here you would typically send the form data to your backend
    console.log('Form submitted:', formData);
    
    // Simulate a successful submission
    setShowSuccess(true);
    setShowError(false);
    
    // Reset form after successful submission
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: ''
    });
    
    setValidated(false);
    
    // Hide success message after 5 seconds
    setTimeout(() => {
      setShowSuccess(false);
    }, 5000);
  };
  
  return (
    <>
      <Header />
      <div className="page-container contact-page bg-light">
        <div className="hero-section text-white py-5 mb-5">
          <Container>
            <Row className="justify-content-center text-center">
              <Col md={8} className="fade-in">
                <h1 className="display-4 fw-bold mb-4">اتصل بنا</h1>
                <p className="lead mb-4">
                  نحن هنا للإجابة على استفساراتك ومساعدتك في كل ما تحتاجه. لا تتردد في التواصل معنا.
                </p>
              </Col>
            </Row>
          </Container>
        </div>

        <Container className="py-5">
          <Row>
            <Col lg={4} className="mb-4 mb-lg-0 fade-in-right delay-1">
              <div className="section-title">
                <h2 className="fw-bold mb-4">معلومات التواصل</h2>
              </div>
              <p className="mb-4">
                يمكنك التواصل معنا من خلال وسائل الاتصال التالية، وسنقوم بالرد عليك في أقرب وقت ممكن.
              </p>
              
              <Card className="contact-card border-0 shadow-sm mb-4 fade-in-up delay-1">
                <Card.Body>
                  <div className="d-flex align-items-center mb-3">
                    <div className="contact-icon-container me-3">
                      <FaPhone className="text-white" />
                    </div>
                    <div>
                      <h5 className="fw-bold mb-0">الهاتف</h5>
                      <p className="mb-0">+20 123 456 7890</p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
              
              <Card className="contact-card border-0 shadow-sm mb-4 fade-in-up delay-2">
                <Card.Body>
                  <div className="d-flex align-items-center mb-3">
                    <div className="contact-icon-container me-3">
                      <FaEnvelope className="text-white" />
                    </div>
                    <div>
                      <h5 className="fw-bold mb-0">البريد الإلكتروني</h5>
                      <p className="mb-0">info@elsamy-edu.com</p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
              
              <Card className="contact-card border-0 shadow-sm mb-4 fade-in-up delay-3">
                <Card.Body>
                  <div className="d-flex align-items-center mb-3">
                    <div className="contact-icon-container me-3">
                      <FaMapMarkerAlt className="text-white" />
                    </div>
                    <div>
                      <h5 className="fw-bold mb-0">العنوان</h5>
                      <p className="mb-0">123 شارع التحرير، القاهرة، مصر</p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
              
              <div className="fade-in-up delay-4">
                <h4 className="fw-bold mb-3 mt-5">تابعنا على</h4>
                <div className="social-icons d-flex">
                  <a href="#" className="social-icon me-3">
                    <FaFacebook />
                  </a>
                  <a href="#" className="social-icon me-3">
                    <FaTwitter />
                  </a>
                  <a href="#" className="social-icon me-3">
                    <FaInstagram />
                  </a>
                  <a href="#" className="social-icon">
                    <FaYoutube />
                  </a>
                </div>
              </div>
            </Col>
            
            <Col lg={8} className="fade-in-left delay-2">
              <Card className="contact-form-card border-0 shadow-sm">
                <Card.Body className="p-4 p-lg-5">
                  <h2 className="fw-bold mb-4">أرسل لنا رسالة</h2>
                  
                  {showSuccess && (
                    <Alert variant="success" onClose={() => setShowSuccess(false)} dismissible>
                      تم إرسال رسالتك بنجاح! سنقوم بالرد عليك في أقرب وقت ممكن.
                    </Alert>
                  )}
                  
                  {showError && (
                    <Alert variant="danger" onClose={() => setShowError(false)} dismissible>
                      حدث خطأ أثناء إرسال رسالتك. يرجى المحاولة مرة أخرى.
                    </Alert>
                  )}
                  
                  <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    <Row>
                      <Col md={6} className="mb-3 fade-in-up delay-1">
                        <Form.Group controlId="name">
                          <Form.Label>الاسم الكامل</Form.Label>
                          <Form.Control
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            placeholder="أدخل اسمك الكامل"
                          />
                          <Form.Control.Feedback type="invalid">
                            يرجى إدخال الاسم الكامل
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      
                      <Col md={6} className="mb-3 fade-in-up delay-2">
                        <Form.Group controlId="email">
                          <Form.Label>البريد الإلكتروني</Form.Label>
                          <Form.Control
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            placeholder="أدخل بريدك الإلكتروني"
                          />
                          <Form.Control.Feedback type="invalid">
                            يرجى إدخال بريد إلكتروني صحيح
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    
                    <Row>
                      <Col md={6} className="mb-3 fade-in-up delay-3">
                        <Form.Group controlId="phone">
                          <Form.Label>رقم الهاتف</Form.Label>
                          <Form.Control
                            type="tel"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            placeholder="أدخل رقم هاتفك"
                          />
                        </Form.Group>
                      </Col>
                      
                      <Col md={6} className="mb-3 fade-in-up delay-4">
                        <Form.Group controlId="subject">
                          <Form.Label>الموضوع</Form.Label>
                          <Form.Select
                            name="subject"
                            value={formData.subject}
                            onChange={handleChange}
                            required
                          >
                            <option value="">اختر الموضوع</option>
                            <option value="استفسار عام">استفسار عام</option>
                            <option value="الدعم الفني">الدعم الفني</option>
                            <option value="الاشتراكات">الاشتراكات</option>
                            <option value="اقتراحات">اقتراحات</option>
                            <option value="أخرى">أخرى</option>
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            يرجى اختيار الموضوع
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    
                    <Form.Group className="mb-4 fade-in-up delay-4" controlId="message">
                      <Form.Label>الرسالة</Form.Label>
                      <Form.Control
                        as="textarea"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                        placeholder="اكتب رسالتك هنا..."
                        style={{ height: '150px' }}
                      />
                      <Form.Control.Feedback type="invalid">
                        يرجى كتابة رسالتك
                      </Form.Control.Feedback>
                    </Form.Group>
                    
                    <div className="text-end fade-in-up delay-4">
                      <Button 
                        variant="primary" 
                        type="submit" 
                        size="lg"
                        className="submit-button px-4 fw-bold"
                      >
                        إرسال الرسالة
                      </Button>
                    </div>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          
          <Row className="mt-5 fade-in-up delay-4">
            <Col>
              <Card className="map-container border-0 shadow-sm">
                <Card.Body className="p-0">
                  <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3453.6730457153323!2d31.2358!3d30.0444!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzDCsDAyJzM5LjgiTiAzMcKwMTQnMDkuMCJF!5e0!3m2!1sen!2seg!4v1616000000000!5m2!1sen!2seg" 
                    width="100%" 
                    height="400" 
                    style={{ border: 0 }} 
                    allowFullScreen 
                    loading="lazy"
                    title="خريطة موقعنا"
                  ></iframe>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Contact;